import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  isMenuOpen: boolean
  showServicesPage: boolean

  scrollToSection(sectionID: string) {
    document.getElementById(sectionID).scrollIntoView()
  }
}
